<template>
  <v-dialog v-model="show" max-width="950px">
    <form-toolbar
      title="Bulk Transactions"
      :showSubmitButton="false"
      :onCloseClick="onCloseClick"
    />
    <v-card class="pa-1">
      <v-tabs v-model="tab">
        <v-tab>Transactions</v-tab>
        <v-tab>Create Transaction</v-tab>
        <div v-if="showEditTab" class="d-flex">
          <v-tab>Edit Transaction </v-tab>
          <v-icon @click="closeEditTab">mdi-close-circle</v-icon>
        </div>
      </v-tabs>
      <v-tabs-items v-model="tab">
        <v-tab-item>
          <bulk-transaction-table
            :items="bulkTransactions"
            :DeleteTransaction="deleteBulkTransaction"
            v-on:editTransaction="editBulkTransaction"
            :items-per-page="15"
          />
        </v-tab-item>
        <v-tab-item>
          <bulk-transaction-form
            v-if="voyageReport"
            ref="bulkTransactionForm"
            :vesselId="voyageReport.vesselId"
            :transaction="transaction"
            :onSubmitClick="submitBulkTransaction"
            :activity="activity"
          />
        </v-tab-item>
        <v-tab-item>
          <bulk-transaction-form
            v-if="voyageReport && !!selectedTransaction"
            ref="bulkTransactionEditForm"
            :vesselId="voyageReport.vesselId"
            :transaction="selectedTransaction"
            :onSubmitClick="submitBulkTransactionEdit"
            :onUpdateAttachmentClick="updateBulkDeliveryNoteFile"
            :removeBulkDeliveryNote="removeBulkDeliveryNoteFile"
            :activity="activity"
          />
        </v-tab-item>
      </v-tabs-items>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapState, mapGetters } from 'vuex';
import dateTimeHelpers from '../../mixins/DateTimeHelpers';
import FormToolbar from '../ui/FormToolbar.vue';
import BulkTransactionTable from './BulkTransactionsTable.vue';
import BulkTransactionForm from './BulkTransactionForm.vue';
import BulkTransactionsHelperMixin from '../../mixins/BulkTransactionsHelpersMixin';
import TankStatusMixin from '../../mixins/TankStatusMixin';
import { BulkTransactionCreateModel } from '../../models/bulk-transaction/BulkTransactionCreateModel';

export default {
  name: 'BulkTransactionDialog',
  props: {
    value: Boolean,
    activity: {
      type: Object,
      required: true,
    },
    onCloseClick: Function,
  },
  components: {
    FormToolbar,
    BulkTransactionTable,
    BulkTransactionForm,
  },
  mixins: [BulkTransactionsHelperMixin, TankStatusMixin],
  data() {
    return {
      tab: null,
      transaction: {},
    };
  },
  mounted() {
    this.resetBulkTransactionValues();
  },
  computed: {
    ...mapState(['voyageReportsStore', 'bulkTransactionsStore']),
    ...mapGetters({
      getActiveSite: 'userStore/getActiveSite',
      isClientConnectedToServer: 'userStore/isClientConnectedToServer',
      getUnsyncedBulkTransactionsForActivity: 'dataSyncStore/getUnsyncedBulkTransactionsForActivity',
    }),
    show: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
    activeSiteId() {
      const site = this.getActiveSite;
      if (!site) {
        return null;
      }
      return site.id;
    },
    bulkTransactions() {
      const { bulkTransactions } = this.activity;
      return [].concat(bulkTransactions).concat(this.getUnsyncedBulkTransactionsForActivity);
    },
    voyageReport() {
      return this.voyageReportsStore ? this.voyageReportsStore.voyageReportDetailsData : {};
    },
    showEditTab() {
      return this.selectedTransaction;
    },
  },
  watch: {
    show(val) {
      if (val) {
        this.resetBulkTransactionValues();
      }
    },
  },
    methods: {
      oldNote() {

      //const bulkTransactionCreateModel = {
      //  vesselActivityId: this.activity.id,
      //  vesselActivityIdc: this.activity.idc ?? null,
      //  vesselActivity: this.activity,
      //  voyageReportId,
      //  siteId: this.activeSiteId,
      //  completedDateTimeLt,
      //  transactionType: this.transaction.transactionType,
      //  vesselName: this.voyageReport.vesselName,
      //  location: this.activity.locationName,
      //  bulk: this.transaction.bulk,
      //  quantity: parseFloat(this.transaction.quantity),
      //  qtyUom: this.transaction.tank.qtyUom,
      //  bulkDeliveryNoteNumber: this.transaction.bulkDeliveryNoteNumber,
      //  bulkDeliveryNoteFile: this.transaction.bulkDeliveryNoteFile,
      //  tankId: this.transaction.tank.id,
      //  comments: this.transaction.comments,
      //};

        // DTO for file upload etc
        //const notCoveredAbove = {
        //  //  voyageReportId
        //  //  bulkDeliveryNoteFile: this.transaction.bulkDeliveryNoteFile,
        //  //  vesselActivityIdc: this.activity.idc ?? null,
        //  //  vesselActivity: this.activity,
        //}

      },
      submitBulkTransaction() { 

        // DTO for creating bulk transaction
        const bulkTransactionCreateModel = new BulkTransactionCreateModel(
          this.activeSiteId,
          this.getCompletedDateTime(this.transaction),
          this.transaction.transactionType,
          this.voyageReport.vesselName,
          this.activity.locationName,
          this.transaction.bulk,
          parseFloat(this.transaction.quantity),
          this.transaction.tank.qtyUom,
          this.transaction.bulkDeliveryNoteNumber,
          this.transaction.comments,
          this.activity.id,
          this.transaction.tank.id);

        const bulkDeliveryNoteFile = this.transaction.bulkDeliveryNoteFile;

        return this.$store.dispatch('bulkTransactionsStore/createBulkTransaction', bulkTransactionCreateModel)
          .then((transaction) => {
            this.onSuccess('Bulk Transaction Created', transaction);
            return transaction;
          })
          .then((bulkTransaction) => {
            // Upload delivery note
            const file = bulkDeliveryNoteFile;
            if (file) {
              const bulkTransactionId = bulkTransaction.id;
              return this.$store.dispatch('bulkTransactionsStore/uploadBulkDeliveryNotePdf', { file, bulkTransactionId })
                .catch((err) => this.onError(`Bulk note file upload failed: ${err.message}`, err));
            }
            return bulkTransaction;
          })
          .then(() => {
            // Refresh bulk avtivity
            this.$emit('refreshSelectedBulkActivity', this.activity.id ?? this.activity.idc);
            this.resetBulkTransactionForm();
            this.$nextTick(() => {
              this.tab = 0;
            });
          })
          .catch((err) => this.onError('Failed to Create Bulk Transaction', err));
      },
      submitBulkTransactionEdit() {

        // Get Id of old one
        const previousVersionId = this.selectedTransaction.id;

        const transaction = this.selectedTransaction;

        const bulkTransactionCreateModel = new BulkTransactionCreateModel(
          this.activeSiteId,
          this.getCompletedDateTime(this.selectedTransaction),
          transaction.transactionType,
          this.voyageReport.vesselName,
          this.activity.locationName,
          transaction.bulk,
          parseFloat(transaction.quantity),
          transaction.tank.qtyUom,
          transaction.bulkDeliveryNoteNumber,
          transaction.comments,
          this.activity.id,
          transaction.tank.id);

        // This is an update, so set the previousVersionId
        bulkTransactionCreateModel.previousVersionId = previousVersionId;

        const bulkDeliveryNoteFile = this.transaction.bulkDeliveryNoteFile;

        return this.$store.dispatch('bulkTransactionsStore/createBulkTransaction', bulkTransactionCreateModel)
          .then((transaction) => {
            this.onSuccess('Bulk Transaction Created', transaction);
            return transaction;
          })
          .then((bulkTransaction) => {
            // Upload delivery note
            const file = bulkDeliveryNoteFile;
            if (file) {
              const bulkTransactionId = bulkTransaction.id;
              return this.$store.dispatch('bulkTransactionsStore/uploadBulkDeliveryNotePdf', { file, bulkTransactionId })
                .catch((err) => this.onError(`Bulk note file upload failed: ${err.message}`, err));
            }
            return bulkTransaction;
          })
          .then(() => {
            // Refresh bulk avtivity
            this.$emit('refreshSelectedBulkActivity', this.activity.id ?? this.activity.idc);
            // this.resetBulkTransactionForm(); TODO - This is broken on updates for some reason
            this.$nextTick(() => {
              this.tab = 0;
            });
          })
          .catch((err) => this.onError('Failed to Create Bulk Transaction', err));



      },
      deleteBulkTransaction(transaction) {
        this.$store.dispatch('bulkTransactionsStore/deleteBulkTransaction', transaction)
          .then((resp) => {
            this.onSuccess('Bulk Transaction Deleted', resp);
            this.$emit('refreshSelectedBulkActivity', this.activity.id ?? this.activity.idc);
          })
          .catch((err) => this.onError('Failed To Delete Bulk Transaction', err));
      },
      editBulkTransaction(transaction) {
        console.log("Loading transaction", transaction);
        this.selectedTransaction = { ...transaction };
        this.setSelectedBulkTransactionInputValues();
        this.$nextTick(() => {
          this.tab = 2;
        });
      },
      updateBulkDeliveryNoteFile(transaction) {
        return this.addBulkDeliveryNoteToTransaction(transaction.bulkDeliveryNoteFile, transaction.id)
          .then(() => {
            this.onSuccess('Bulk Delivery Note added to Transaction');
            this.$emit('refreshSelectedBulkActivity', this.activity.id ?? this.activity.idc);
          })
          .catch((err) => this.onError(`Failed to attach note to transaction: ${err.message}`));
      },
      removeBulkDeliveryNoteFile(transactionId) {
        return this.$store.dispatch('bulkTransactionsStore/removeBulkDeliveryNote', transactionId)
          .then(() => {
            this.onSuccess('Bulk Delivery Note Removed');
            this.$emit('refreshSelectedBulkActivity', this.activity.id ?? this.activity.idc);

            const refreshedTransaction = this.bulkTransactions.find((x) => x.id === transactionId);
            this.selectedTransaction = { ...refreshedTransaction };
            this.setSelectedBulkTransactionInputValues();
          })
          .catch((err) => this.onError(`Failed to remove note from transaction: ${err.message}`));
      },
      resetBulkTransactionValues() {
        this.transaction = {
          isTankUpdate: true,
          completedDate: dateTimeHelpers.getCurrentDateLt(),
          completedTime: dateTimeHelpers.getCurrentTimeWithSecondsLt(),
        };
      },
      resetBulkTransactionForm() {
        this.resetBulkTransactionValues();
        this.$refs.bulkTransactionForm.resetForm();
      },
      closeEditTab() {
        this.tab = 0;
        this.$nextTick(() => {
          this.selectedTransaction = null;
        });
      },
  },
};
</script>

<style>
</style>
